import { useDispatch } from "hooks/useDispatch"
import { Divider } from "primereact/divider"
import { InputSwitch } from "primereact/inputswitch"
import { useCallback } from "react"

const InputSwitchSetting = ({
  name,
  checked,
  setFuntion,
  onHideFuntions = [],
  disabled,
  hide,
  noDispatch,
}: $TSMigrationFixMe) => {
  const dispatch = useDispatch()

  const switchFuntion = useCallback(() => {
    const mySwitchFuntion = () => setFuntion(!checked)

    if (noDispatch) {
      mySwitchFuntion()
    } else {
      dispatch(mySwitchFuntion())
    }

    if (checked) {
      // @ts-expect-error TS(7006): Parameter 'onHideFuntion' implicitly has an 'any' ...
      onHideFuntions.forEach((onHideFuntion) => {
        const hideFuntion = onHideFuntion[0]
        const newValue = onHideFuntion[1]

        dispatch(hideFuntion(newValue))
      })
    }
  }, [checked, dispatch, noDispatch, onHideFuntions, setFuntion])

  if (hide) {
    return null
  }

  return (
    <>
      <div className='row justify-content-between align-items-center mt-3 px-3'>
        <span>{name}</span>

        <InputSwitch
          inputId={name}
          disabled={disabled}
          checked={checked}
          onChange={switchFuntion}
        />
      </div>

      <Divider />
    </>
  )
}

export default InputSwitchSetting
